import spinner from "../../../assets/spinner.svg";

export default function Spinner() {
  return (
    <div className="flex justify-center items-center w-28 bg-gray-100 h-7 mt-2 rounded-md">
      <img src={spinner} alt="" height={20} width={20} />
    </div>
  );
}
